import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { rentVariantColumns, serviceColumns } from '@Constants/TableColumns';
import { type ApiContainerType, type ApiRentVariant, type ApiService, EnumFrontendLayoutSetting } from '@Model';
import { FrameEditRentVariant, FrameEditService } from '@Modules/Stammdaten';
import {
    type AsyncStateUpdate,
    Card,
    Grid,
    GridColumns,
    type IGuiBinder,
    useLinkedField,
    useLinkProperty,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-22T11:31:40+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    binder: IGuiBinder<ApiContainerType>;
    baseApiObjectPath: string;
    requestUpdateState: AsyncStateUpdate<ApiContainerType>;
}

export const ContainerTypeRentSection = memo(function ContainerTypeRentSection({
    binder,
    baseApiObjectPath,
    requestUpdateState,
}: IProps) {
    const i18n = useTranslate('');

    const linkRentService = useLinkedField<ApiContainerType, ApiService>(
        baseApiObjectPath,
        'rent_service',
        FrameEditService,
        true,
        requestUpdateState,
    );
    const linkRentVariant = useLinkedField<ApiContainerType, ApiRentVariant>(
        baseApiObjectPath,
        'rent_variant',
        FrameEditRentVariant,
        true,
        requestUpdateState,
    );

    const rentServiceField = useLinkProperty(binder, linkRentService.linkApi);
    const rentVariantField = useLinkProperty(binder, linkRentVariant.linkApi);

    return (
        <Card name="rent" label="Miete">
            <Grid>
                <GridColumns spans={[6, 6]}>
                    <LinkedFieldWithLayoutSettings<ApiService>
                        layoutSettingsContext={EnumFrontendLayoutSetting.ServicesTableLayout}
                        {...rentServiceField}
                        {...linkRentService.events}
                        columns={serviceColumns}
                        label={i18n('Mietleistung')}
                    />
                    <LinkedFieldWithLayoutSettings<ApiRentVariant>
                        layoutSettingsContext={EnumFrontendLayoutSetting.RentVariantsTableLayout}
                        {...rentVariantField}
                        {...linkRentVariant.events}
                        columns={rentVariantColumns}
                        label={i18n('Miet-Variante')}
                    />
                </GridColumns>
            </Grid>
        </Card>
    );
});
